import React, { useMemo } from 'react';

import { orderBy } from 'lodash';
import { Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { useQueryActivityCodesByVersion } from 'api/queries/activityCodesByVersion.query';

import { MULTI_SELECT_MAX_ITEMS } from 'components/common/Constants/constants';

import { ProgramStatusUrlParams } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';
import { MyCustomSelect } from 'components/common';
import { mapper } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/components/ActivityCodesSelect/ActivityCodesSelect.utils';

export const ActivityCodesSelect = ({ methods, name }) => {
    const hashcode = Object.values(useParams<ProgramStatusUrlParams>()).filter(Boolean).join(',');
    const { versionList: versionFromHashMap } = useHashmapConverter(hashcode);

    const { data: activityCodes } = useQueryActivityCodesByVersion({
        latestVersion: versionFromHashMap[0]?.versionDbId,
    });

    const options = useMemo<ISelectOption<number>[]>(
        () =>
            activityCodes
                ? orderBy(activityCodes.map(mapper), [(item: any) => item['label'].toLowerCase()], ['asc'])
                : [],
        [activityCodes],
    );

    const handleChange = (value: readonly ISelectOption<number>[]) => {
        methods?.setValue(
            name,
            value.map((item) => item.value),
            { shouldDirty: true },
        );
    };

    const handleValue = (value: number[] | undefined) => {
        return activityCodes?.map(mapper).filter((item) => value?.map(Number).includes(item.value)) || null;
    };

    return (
        <Controller
            render={({ field }) => {
                return (
                    <MyCustomSelect<ISelectOption<number>, true>
                        {...field}
                        options={options}
                        isMulti
                        isOptionDisabled={() => field.value?.length >= MULTI_SELECT_MAX_ITEMS}
                        onChange={handleChange}
                        value={handleValue(field.value)}
                        placeholder={'Select activity or start typing its name...'}
                    />
                );
            }}
            name={name}
            control={methods?.control}
        />
    );
};
